// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as MediaApiModel$PorterinFeature from "../../../media/domain/api-models/MediaApiModel.mjs";
import * as SharedApiModel$PorterinFeature from "../../../core/domain/api-models/SharedApiModel.mjs";

function area_list_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var area_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict._0, "area_name"), null));
  if (area_name.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              area_name: area_name._0
            }
          };
  }
  var e = area_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".area_name" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function areas_served_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var area_list = Decco.arrayFromJson(area_list_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "area_list"), null));
    if (area_list.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                title: title._0,
                area_list: area_list._0
              }
            };
    }
    var e = area_list._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".area_list" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function service_description_item_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var sub_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_text"), null));
    if (sub_text.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                title: title._0,
                sub_text: sub_text._0
              }
            };
    }
    var e = sub_text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_text" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function service_description_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var service_description_items = Decco.arrayFromJson(service_description_item_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "service_description_items"), null));
    if (service_description_items.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                title: title._0,
                service_description_items: service_description_items._0
              }
            };
    }
    var e = service_description_items._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".service_description_items" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function best_for_sending_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var image = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
  if (image.TAG === /* Ok */0) {
    var category = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "category"), null));
    if (category.TAG === /* Ok */0) {
      var link = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "link"), null));
      if (link.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  image: image._0,
                  category: category._0,
                  link: link._0
                }
              };
      }
      var e = link._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".link" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = category._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".category" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = image._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".image" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function vehicle_attributes_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var vehicle_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_name"), null));
  if (vehicle_name.TAG === /* Ok */0) {
    var capacity = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "capacity"), null));
    if (capacity.TAG === /* Ok */0) {
      var vehicle_image = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_image"), null));
      if (vehicle_image.TAG === /* Ok */0) {
        var fare = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fare"), null));
        if (fare.TAG === /* Ok */0) {
          var fare_details = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "fare_details"), null));
          if (fare_details.TAG === /* Ok */0) {
            var best_for_sending = Decco.arrayFromJson(best_for_sending_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "best_for_sending"), null));
            if (best_for_sending.TAG === /* Ok */0) {
              var capacity_icon = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "capacity_icon"), null));
              if (capacity_icon.TAG === /* Ok */0) {
                var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
                if (url.TAG === /* Ok */0) {
                  var vehicle_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_type"), null));
                  if (vehicle_type.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: {
                              vehicle_name: vehicle_name._0,
                              capacity: capacity._0,
                              vehicle_image: vehicle_image._0,
                              fare: fare._0,
                              fare_details: fare_details._0,
                              best_for_sending: best_for_sending._0,
                              capacity_icon: capacity_icon._0,
                              url: url._0,
                              vehicle_type: vehicle_type._0
                            }
                          };
                  }
                  var e = vehicle_type._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".vehicle_type" + e.path,
                            message: e.message,
                            value: e.value
                          }
                        };
                }
                var e$1 = url._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".url" + e$1.path,
                          message: e$1.message,
                          value: e$1.value
                        }
                      };
              }
              var e$2 = capacity_icon._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".capacity_icon" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                      }
                    };
            }
            var e$3 = best_for_sending._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".best_for_sending" + e$3.path,
                      message: e$3.message,
                      value: e$3.value
                    }
                  };
          }
          var e$4 = fare_details._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".fare_details" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
        }
        var e$5 = fare._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".fare" + e$5.path,
                  message: e$5.message,
                  value: e$5.value
                }
              };
      }
      var e$6 = vehicle_image._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".vehicle_image" + e$6.path,
                message: e$6.message,
                value: e$6.value
              }
            };
    }
    var e$7 = capacity._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".capacity" + e$7.path,
              message: e$7.message,
              value: e$7.value
            }
          };
  }
  var e$8 = vehicle_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".vehicle_name" + e$8.path,
            message: e$8.message,
            value: e$8.value
          }
        };
}

function vehicle_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = vehicle_attributes_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function vehicle_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = vehicle_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function vehicles_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = Decco.arrayFromJson(vehicle_info_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function vehicle_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var fare = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fare"), null));
  if (fare.TAG === /* Ok */0) {
    var fare_details = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fare_details"), null));
    if (fare_details.TAG === /* Ok */0) {
      var vehicle = vehicle_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle"), null));
      if (vehicle.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  fare: fare._0,
                  fare_details: fare_details._0,
                  vehicle: vehicle._0
                }
              };
      }
      var e = vehicle._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".vehicle" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = fare_details._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".fare_details" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = fare._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".fare" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function multiple_vehicle_inventory_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var know_more_cta = SharedApiModel$PorterinFeature.know_more_cta_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "know_more_cta"), null));
    if (know_more_cta.TAG === /* Ok */0) {
      var light_vehicles = vehicles_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "light_vehicles"), null));
      if (light_vehicles.TAG === /* Ok */0) {
        var heavy_vehicles = vehicles_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "heavy_vehicles"), null));
        if (heavy_vehicles.TAG === /* Ok */0) {
          var capacity_icon = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "capacity_icon"), null));
          if (capacity_icon.TAG === /* Ok */0) {
            var light_vehicles_title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "light_vehicles_title"), null));
            if (light_vehicles_title.TAG === /* Ok */0) {
              var heavy_vehicles_title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "heavy_vehicles_title"), null));
              if (heavy_vehicles_title.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          title: title._0,
                          know_more_cta: know_more_cta._0,
                          light_vehicles: light_vehicles._0,
                          heavy_vehicles: heavy_vehicles._0,
                          capacity_icon: capacity_icon._0,
                          light_vehicles_title: light_vehicles_title._0,
                          heavy_vehicles_title: heavy_vehicles_title._0
                        }
                      };
              }
              var e = heavy_vehicles_title._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".heavy_vehicles_title" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = light_vehicles_title._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".light_vehicles_title" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = capacity_icon._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".capacity_icon" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = heavy_vehicles._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".heavy_vehicles" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = light_vehicles._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".light_vehicles" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = know_more_cta._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".know_more_cta" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function vehicle_inventory_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var know_more_cta = SharedApiModel$PorterinFeature.know_more_cta_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "know_more_cta"), null));
    if (know_more_cta.TAG === /* Ok */0) {
      var vehicle_data = vehicle_data_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_data"), null));
      if (vehicle_data.TAG === /* Ok */0) {
        var capacity_icon = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "capacity_icon"), null));
        if (capacity_icon.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    title: title._0,
                    know_more_cta: know_more_cta._0,
                    vehicle_data: vehicle_data._0,
                    capacity_icon: capacity_icon._0
                  }
                };
        }
        var e = capacity_icon._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".capacity_icon" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = vehicle_data._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".vehicle_data" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = know_more_cta._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".know_more_cta" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function internal_link_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var sub_text = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_text"), null));
    if (sub_text.TAG === /* Ok */0) {
      var link = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "link"), null));
      if (link.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  title: title._0,
                  sub_text: sub_text._0,
                  link: link._0
                }
              };
      }
      var e = link._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".link" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = sub_text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_text" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function internal_links_section_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var internal_links_title_1 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "internal_links_title_1"), null));
    if (internal_links_title_1.TAG === /* Ok */0) {
      var internal_links_title_2 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "internal_links_title_2"), null));
      if (internal_links_title_2.TAG === /* Ok */0) {
        var internal_links_1 = Decco.arrayFromJson(internal_link_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "internal_links_1"), null));
        if (internal_links_1.TAG === /* Ok */0) {
          var internal_links_2 = Decco.arrayFromJson(internal_link_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "internal_links_2"), null));
          if (internal_links_2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      title: title._0,
                      internal_links_title_1: internal_links_title_1._0,
                      internal_links_title_2: internal_links_title_2._0,
                      internal_links_1: internal_links_1._0,
                      internal_links_2: internal_links_2._0
                    }
                  };
          }
          var e = internal_links_2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".internal_links_2" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = internal_links_1._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".internal_links_1" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = internal_links_title_2._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".internal_links_title_2" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = internal_links_title_1._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".internal_links_title_1" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function services_attributes_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var service_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "service_name"), null));
  if (service_name.TAG === /* Ok */0) {
    var service_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "service_type"), null));
    if (service_type.TAG === /* Ok */0) {
      var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
      if (url.TAG === /* Ok */0) {
        var service_icon = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "service_icon"), null));
        if (service_icon.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    service_name: service_name._0,
                    service_type: service_type._0,
                    url: url._0,
                    service_icon: service_icon._0
                  }
                };
        }
        var e = service_icon._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".service_icon" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = url._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".url" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = service_type._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".service_type" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = service_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".service_name" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function services_attribute_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = services_attributes_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function services_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = Decco.arrayFromJson(services_attribute_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function service_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = services_attribute_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function other_services_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var services = services_data_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "services"), null));
    if (services.TAG === /* Ok */0) {
      var arrow_icon = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "arrow_icon"), null));
      if (arrow_icon.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  title: title._0,
                  services: services._0,
                  arrow_icon: arrow_icon._0
                }
              };
      }
      var e = arrow_icon._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".arrow_icon" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = services._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".services" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function popular_outstation_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var text_subtext = Decco.arrayFromJson(SharedApiModel$PorterinFeature.text_subtext_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "text_subtext"), null));
    if (text_subtext.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                title: title._0,
                text_subtext: text_subtext._0
              }
            };
    }
    var e = text_subtext._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".text_subtext" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

export {
  area_list_decode ,
  areas_served_decode ,
  service_description_item_decode ,
  service_description_decode ,
  best_for_sending_decode ,
  vehicle_attributes_decode ,
  vehicle_info_decode ,
  vehicle_decode ,
  vehicles_decode ,
  vehicle_data_decode ,
  multiple_vehicle_inventory_decode ,
  vehicle_inventory_decode ,
  internal_link_decode ,
  internal_links_section_decode ,
  services_attributes_decode ,
  services_attribute_decode ,
  services_data_decode ,
  service_data_decode ,
  other_services_decode ,
  popular_outstation_decode ,
}
/* No side effect */
